import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { EventCard } from "../components/Events/EventCard";
import { PageHero } from "../components/Global/PageHero";
import { BackToTop } from "../templates/BackToTop";

export const Events = () => (
  <Fragment>
    <PageHero
      eyebrow="Church Calendar"
      title="Programs &"
      highlight="Events"
      subtitle="Catch up on amazing events happening at CCC Salvation Parish."
      extra={
        <Link
          to="/events/yearly"
          onClick={() => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })}
          className="font-abel text-sm uppercase tracking-widest px-6 py-2.5 rounded-full transition-all duration-200 hover:scale-105"
          style={{
            border: "1px solid rgba(255,192,0,0.5)",
            color: "#ffc000",
            background: "rgba(255,192,0,0.08)",
            textDecoration: "none",
          }}
        >
          View Yearly Programs →
        </Link>
      }
    />
    <EventCard />
    <BackToTop />
  </Fragment>
);
